'use client';
import { usePopover_unstable } from '@fluentui/react-popover';
export const useTeachingPopover_unstable = (props)=>{
    const popoverState = usePopover_unstable(props);
    var _props_withArrow, _props_trapFocus;
    return {
        ...popoverState,
        withArrow: (_props_withArrow = props.withArrow) !== null && _props_withArrow !== void 0 ? _props_withArrow : true,
        // We trap focus because the default TeachingPopover view has buttons/carousel.
        trapFocus: (_props_trapFocus = props.trapFocus) !== null && _props_trapFocus !== void 0 ? _props_trapFocus : true
    };
};
